// FloatingMenu.js
import React, { useState } from "react";
import imgUrl from "../assets/images/imgUrl";
import { Fab, Zoom } from "@mui/material";
import { Add, Home, Info, EmojiEvents } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function FloatingMenu({onSendData}) {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // show only on mobile

  // if (!isMobile) return null; // don’t render on desktop/tablet

  const handleToggle = () => setOpen((prev) => !prev);


 
  const sendDataToParent = (value) => {
    onSendData(value); // Call parent function
  };

  const actions = [
    { icon: <img src={imgUrl.award} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "Awards", value: "awards" },
    { icon:<img src={imgUrl.doctrate} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "Doctrates", value: "doctrates" },
    { icon: <img src={imgUrl.dlitt} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "D. Litt", value: "dlitt" },
    { icon: <img src={imgUrl.professorship} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "Professorship", value: "professorship" },
    { icon: <img src={imgUrl.knighthood} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "Knighthood", value: "knighthood" },
    { icon: <img src={imgUrl.princehood} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "Princehood", value: "princehood" },
    { icon: <img src={imgUrl.manOftheYear} alt="My Icon" style={{ maxWidth: 22, height:"auto" }} />, name: "Man Of the Year", value: "manoftheyear" },
  ];

  return (
    <div style={{ position: "fixed", bottom: 150, right: 20, zIndex: 1000 }} className="floatingAwardicon">
       <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-12px); }
            60% { transform: translateY(-6px); }
          }
        `}
      </style>
      {/* Floating Menu Options */}
      {actions.map((action, index) => {

        const bgColor =
          action.value === "doctrates" ||
            action.value === "professorship" ||
            action.value === "princehood"
            ? "#df5b55" 
            : "#fefae7"; 

        return (
          <Zoom
            key={action.name}
            in={open}
            style={{
              transitionDelay: open ? `${index * 50}ms` : "0ms",
            }}
          >
            <Fab
              size="small"
              onClick={() => sendDataToParent(action.value)}
              style={{
                position: "absolute",
                bottom: 70 + index * 64,
                right: 0,
                width: 55,
                height: 55,
                backgroundColor: bgColor,
              }}
              aria-label={action.name}
            >
              {action.icon}
            </Fab>
          </Zoom>
        );
      })}


      {/* Main FAB */}
      <Fab color="secondary" onClick={handleToggle} style={{backgroundColor:"#57585a", animation: "bounce 2s infinite",}}>
        <EmojiEvents style={{width: 36,height: 40}}/>
      </Fab>
    </div>
  );
}
